import React, { Component } from 'react';
import styled from 'styled-components';
import { Typo, HR as _HR } from 'tmt-ui-kit';
import PropTypes from 'prop-types';
import Collapsed from '~/components/HelpCenter/Collapsed';

const Container = styled.div`
  width: 100%;
  margin-top: 48px;

  @media screen and (max-width: 600px) {
    margin-top: 24px;
  }
`;

const Header = styled(Typo.HeaderThree)`
  margin: 0px !important;
`;

const HR = styled(_HR) `
  margin-bottom: 16px;
`;

const SeeAll = styled(Typo.HeaderThree)`
  cursor: pointer;
  font-size: 14px !important;
  color: ${props => props.theme.blue} !important;
  font-weight: 500 !important;
`;

class MenuItem extends Component {
  static propTypes = {
    data: PropTypes.object,
    subToggleId: PropTypes.number,
    contentIndex: PropTypes.number,
    onClickSetContentIndex: PropTypes.func
  };

  state = {
    seeAll: false,
  }

  onToggleSeeAll = () => {
    this.setState(state => ({ seeAll: !state.seeAll }));
  }

  render() {
    const { subToggleId, contentIndex } = this.props;
    return (
      <Container>
        <Header>
          {this.props.data.subTitle
            ? `${this.props.data.title} - ${this.props.data.subTitle[subToggleId].title}` : this.props.data.title
          }
        </Header>
        <HR />
        {this.props.data.subTitle
          ? this.props.data.subTitle && this.props.data.subTitle[subToggleId].items.map((item, index) => (
            <Collapsed
              isActive={parseInt(contentIndex, 0) === index}
              key={index + item.header}
              header={item.header}
              content={item.content}
              isSeeAll={index > 3}
              seeAll={this.state.seeAll}
              index={index}
              onClickSetContentIndex={this.props.onClickSetContentIndex}
            />
          )) : this.props.data.items.map((item, index) => (
            <Collapsed
              isActive={parseInt(contentIndex, 0) === index}
              key={index + item.header}
              header={item.header}
              content={item.content}
              isSeeAll={index > 3}
              seeAll={this.state.seeAll}
              index={index}
              onClickSetContentIndex={this.props.onClickSetContentIndex}
            />
          ))
        }
        {this.props.data.subTitle
          ? this.props.data.subTitle && this.props.data.subTitle[subToggleId].items.length > 4 && (
            <SeeAll onClick={this.onToggleSeeAll}>
              {this.state.seeAll ? 'Show Less' : `See All ${this.props.data.subTitle[subToggleId].items.length} Articles`}
            </SeeAll>
          ) : this.props.data.items.length > 4 && (
            <SeeAll onClick={this.onToggleSeeAll}>
              {this.state.seeAll ? 'Show Less' : `See All ${this.props.data.items.length} Articles`}
            </SeeAll>
          )
        }
      </Container>
    );
  }
}

export default MenuItem;
